import { ProgramType } from '../../enums/program-type.enum';

export class AvailableProgramModel {
  constructor(public readonly Id: number, public readonly Name: string, public readonly Type: ProgramType) {}
}
